import { Button } from "@/common/components/button";
import { AddressWrapper } from "./sub/style";
import { useState } from "react";
import { Modal } from "@/common/components/modal";
import AddressCard from "./sub/address-card";
import { newAddressForm } from "./sub/data";
import Form from "@/common/components/form/Form";
import useQuery from "@/hooks/useQuery";
import { COMPANY_ADDRESS_URL, COMPANY_ADDRESSES_URL } from "@/common/constants";
import { useApiCallHandling } from "@/hooks/useApiCallHandling";

const Address = () => {
  const [showModal, setShowModal] = useState(false);
  const { data: addressData, refetch } = useQuery(COMPANY_ADDRESSES_URL);
  const [loading, setLoading] = useState<boolean>(false);
  const makeRequest = useApiCallHandling();

  const handleSubmit = (data: any) => {
    setLoading(true);
    makeRequest(
      COMPANY_ADDRESS_URL,
      "POST",
      data,
      () => {
        refetch();
        setShowModal(false);
      },
      () => console.log,
      () => setLoading(false),
    );
  };

  return (
    <AddressWrapper>
      <div className="button-wrapper">
        <Button onClick={() => setShowModal(true)}>Add New Address</Button>
      </div>
      <div className="addresses">
        {addressData?.map((item: any, index: number) => (
          <div key={item.id} className="address-card">
            <AddressCard refetch={refetch} index={index + 1} address={item} />
          </div>
        ))}
      </div>
      <Modal
        isOpen={showModal}
        close={() => setShowModal(false)}
        title="Create New Address"
      >
        <div className="modal max-w-[900px] md:w-[700px]">
          <Form
            formInputs={newAddressForm}
            processInputs={handleSubmit}
            loadingState={loading}
          />
        </div>
      </Modal>
    </AddressWrapper>
  );
};

export default Address;
